declare global {
    interface Window {
        env: {
            type: 'production' | 'development',
            apiURL: string,
            regionName: string
            base: string
        };
    }
}
window.env = window.env || {} as Window['env'];

export class AppConfig {
    public static readonly ENV = new AppConfig();

    public readonly PRODUCTION: boolean = window.env.type === 'production';
    public readonly BASE_URL: string = window.env.base;
    public readonly API_URL: string = window.env.apiURL;

    private constructor() {

    }
}
